import {
  Box,
  Button,
  Tab,
  Tabs,
  Typography,
} from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import DownloadIcon from '@mui/icons-material/Download'
import React, { useState } from 'react'
import type { RenderedConfig } from '../../types'

interface Props {
  config: RenderedConfig
}

export default function ConfigOutput({ config }: Props) {
  const [tabIndex, setTabIndex] = useState(0)

  const allFiles = [
    ...(config.mainTemplate ? [{ filename: 'docker-compose.yml', content: config.mainTemplate }] : []),
    ...config.files.map(f => ({ filename: f.filename, content: f.content })),
  ]

  if (allFiles.length === 0) return null

  const current = allFiles[tabIndex] || allFiles[0]

  const handleCopy = () => {
    navigator.clipboard.writeText(current.content)
  }

  const handleDownload = () => {
    const blob = new Blob([current.content], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = current.filename
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <Box>
      <Tabs
        value={tabIndex}
        onChange={(_, v) => setTabIndex(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        {allFiles.map((f, i) => (
          <Tab key={i} label={f.filename} />
        ))}
      </Tabs>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
        <Button size="small" startIcon={<ContentCopyIcon />} onClick={handleCopy}>
          Copy
        </Button>
        <Button size="small" startIcon={<DownloadIcon />} onClick={handleDownload}>
          Download
        </Button>
      </Box>
      <Box
        component="pre"
        sx={{
          bgcolor: 'grey.900',
          color: 'grey.100',
          p: 2,
          borderRadius: 1,
          overflow: 'auto',
          maxHeight: 500,
          fontSize: '0.85rem',
          lineHeight: 1.5,
        }}
      >
        <code>{current.content}</code>
      </Box>
    </Box>
  )
}
